//wordpress dependencies
const { __ } = wp.i18n;
const { InspectorControls, PanelColorSettings, MediaUpload } = wp.blockEditor;

import {
	PanelBody,
	BaseControl,
	ButtonGroup,
	Button,
	SelectControl,
	RangeControl,
	Dropdown,
	TabPanel,
	ColorPalette,
	ToggleControl,
	__experimentalUnitControl as UnitControl,
} from "@wordpress/components";
const { useEffect, useState } = wp.element;

//internal dependencies
import Select from 'react-select';
import ColorControl from "../../util/color-control";
import DimensionsControl from "../../util/dimensions-control";
import UnitControlCustom from "../../util/unit-control";
import {
	NORMAL_HOVER,
	TEXT_ALIGN,
	FONT_WEIGHTS,
	TEXT_TRANSFORM,
	STYLE_OPTIONS,
	ORDER_OPTIONS,
	SORT_OPTIONS,
	COLORS,
	COL_OPTIONS,
	THUMB_POSITIONS,
	VIEW_OPTIONS,
	AUTOPLAY_DELAY,
	DOT_STYLE_OPTIONS,
	ARROW_POSITION
} from "./constants";

//external dependencies
import axios from "axios";
import Qs from 'qs';

function Inspector(props) {
	const { attributes, setAttributes, listingsSideEffectChange } = props;
	const {
		cats,
		locations,
		listing_type,
		image_size,
		custom_image_width,
		custom_image_height,
		promotion_in,
		promotion_not_in,
		orderby,
		sortby,
		perPage,
		col_padding,
		content_padding,
		col_style,
		meta_margin,
		content_margin,
		container_margin,
		container_padding,
		containerBGColor,
		content_visibility,
		content_limit,
		col_xl,
		col_lg,
		col_md,
		col_sm,
		col_mobile,
		badge_padding,
		badge_margin,
		title_margin,
		price_margin,
		colBGColor,
		colBorderColor,
		colBorderWith,
		colBorderRadius,
		colBoxShadow,
		colBoxShadowHover,
		colBoxShadowStyle,
		pfeaturedBDColor,
		pfeaturedBGColor,
		ptopBDColor,
		ptopBGColor,
		titleTypo,
		titleColor,
		titleHoverColor,
		titleColorStyle,
		badgeTypo,
		soldTypo,
		soldBGColor,
		soldColor,
		bnewBGColor,
		bnewColor,
		bfeaturedColor,
		bfeaturedBGColor,
		btopBGColor,
		btopColor,
		bbumpBGColor,
		bbumpColor,
		bpopularBGColor,
		bpopularColor,
		metaTypo,
		metaColorStyle,
		metaColor,
		metaHoverColor,
		metaIconColor,
		metaIconHoverColor,
		metaCatColor,
		metaCatHoverColor,
		priceColor,
		priceBGColor,
		priceFontSize,
		priceFontWeight,
		unitLabelColor,
		unitLFSize,
		unitLFSizeWeight,
		btnColorStyle,
		btnBGColor,
		btnBGHoverColor,
		btnColor,
		btnHoverColor,
		btnBorderColor,
		btnHoverBorderColor,
		contentTypo,
		slider_options,
		arrowBGColor,
		arrowBGHoverColor,
		arrowIconColor,
		arrowIconHoverColor,
		dotBGColor,
		dotActiveBGColor,
		dotSpacing,

	} = attributes;

	const TITLE_SIZE_MAX = titleTypo["size"]["unit"] === "em" ? 10 : 100;
	const TITLE_SIZE_STEP = titleTypo["size"]["unit"] === "em" ? 0.1 : 1;
	const BADGE_SIZE_MAX = badgeTypo["size"]["unit"] === "em" ? 10 : 100;
	const BADGE_SIZE_STEP = badgeTypo["size"]["unit"] === "em" ? 0.1 : 1;
	const SOLD_SIZE_MAX = soldTypo["size"]["unit"] === "em" ? 10 : 100;
	const SOLD_SIZE_STEP = soldTypo["size"]["unit"] === "em" ? 0.1 : 1;
	const META_SIZE_MAX = metaTypo["size"]["unit"] === "em" ? 10 : 100;
	const META_SIZE_STEP = metaTypo["size"]["unit"] === "em" ? 0.1 : 1;
	const CONTENT_SIZE_MAX = contentTypo["size"]["unit"] === "em" ? 10 : 100;
	const CONTENT_SIZE_STEP = contentTypo["size"]["unit"] === "em" ? 0.1 : 1;

	const [catList, setCatList] = useState([]);
	const [locationList, setLocationList] = useState([]);
	const [listingType, setListingType] = useState([]);
	const [promotionType, setPromotionType] = useState([]);
	const [imageSize, setImageSize] = useState([]);

	useEffect(() => {
		let data = {
			action: 'rtcl_gb_get_all_image_size_ajax',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				if (response.data.data) {
					let imageSize = [];
					let ai = 0;
					for (const [value, label] of Object.entries(response.data.data)) {
						imageSize[ai] = { value, label };
						ai++;
					}
					setImageSize([...imageSize])
				} else {
					setImageSize([])
				}
			})
			.catch((error) => console.log(error));
	}, []);

	useEffect(() => {
		let data = {
			action: 'rtcl_gb_categories',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
			portion: 'listing'
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				let catListings = [];
				let ai = 0;
				for (const [value, label] of Object.entries(response.data)) {
					catListings[ai] = { value, label };
					ai++;
				}
				setCatList([...catListings])
			})
			.catch((error) => console.log(error));
	}, []);

	useEffect(() => {
		let data = {
			action: 'rtcl_gb_location_ajax',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				let locationListings = [];
				let ai = 0;
				for (const [value, label] of Object.entries(response.data)) {
					locationListings[ai] = { value, label };
					ai++;
				}
				setLocationList([...locationListings])
			})
			.catch((error) => console.log(error));
	}, []);

	useEffect(() => {
		let data = {
			action: 'rtcl_gb_listing_type_ajax',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				let types = [];
				let ai = 0;
				for (const [value, label] of Object.entries(response.data)) {
					types[ai] = { value, label };
					ai++;
				}
				setListingType([...types])
			})
			.catch((error) => console.log(error));
	}, []);

	useEffect(() => {
		let data = {
			action: 'rtcl_gb_listing_promotion_ajax',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				let propotions = [];
				let ai = 0;
				for (const [value, label] of Object.entries(response.data)) {
					propotions[ai] = { value, label };
					ai++;
				}
				setPromotionType([...propotions])
			})
			.catch((error) => console.log(error));
	}, []);

	return (
		<InspectorControls key="controls">
			<div className="rtcl-gb-panel-control">
				<TabPanel
					className="rtcl-gb-parent-tab-panel"
					activeClass="active-tab"
					tabs={[
						{
							name: "general",
							title: "General",
							className: "rtcl-gb-tab general",
						},
						{
							name: "styles",
							title: "Styles",
							className: "rtcl-gb-tab styles",
						},
						{
							name: "advance",
							title: "Advance",
							className: "rtcl-gb-tab advance",
						},
					]}
				>
					{(tab) => (
						<div className={"rtcl-gb-tab-controls" + tab.name}>

							{tab.name === "general" && (
								<>
									<PanelBody title={__("Layout", "classified-listing")} initialOpen={true}>
										<SelectControl
											label={__('Style', 'classified-listing')}
											options={STYLE_OPTIONS}
											value={col_style["style"]}
											onChange={(style) => setAttributes({
												col_style: { ...col_style, style }
											})}
										/>
									</PanelBody>

									<PanelBody title={__("Filter", "classified-listing")} initialOpen={false}>
										<div className="components-base-control__field">
											<label className="components-base-control__label" htmlFor="react-select-2-input">{__('Promotions', 'classified-listing')}</label>
											<Select
												options={promotionType}
												value={promotion_in}
												onChange={(value) => {
													setAttributes({ promotion_in: value }),
														listingsSideEffectChange()
												}}
												isMulti={true}
												closeMenuOnSelect={false}
											/>
										</div>

										<div className="components-base-control__field">
											<label className="components-base-control__label" htmlFor="react-select-2-input">{__('Promotions Excludes', 'classified-listing')}</label>
											<Select
												options={promotionType}
												value={promotion_not_in}
												onChange={(value) => {
													setAttributes({ promotion_not_in: value }),
														listingsSideEffectChange()
												}}
												isMulti={true}
												closeMenuOnSelect={false}
											/>
										</div>

										<SelectControl
											label={__('Listing Type', 'classified-listing')}
											options={listingType}
											value={listing_type}
											onChange={(value) => {
												setAttributes({ listing_type: value }),
													listingsSideEffectChange()
											}}
										/>

										<div className="components-base-control__field">
											<label className="components-base-control__label" htmlFor="react-select-2-input">{__('Categories', 'classified-listing')}</label>
											<Select
												options={catList}
												value={cats}
												onChange={(value) => {
													setAttributes({ cats: value }),
														listingsSideEffectChange()
												}}
												isMulti={true}
												closeMenuOnSelect={false}
											/>
										</div>

										<div className="components-base-control__field">
											<label className="components-base-control__label" htmlFor="react-select-2-input">{__('Locations', 'classified-listing')}</label>
											<Select
												options={locationList}
												value={locations}
												onChange={(value) => {
													setAttributes({ locations: value }),
														listingsSideEffectChange()
												}}
												isMulti={true}
												closeMenuOnSelect={false}
											/>
										</div>

										<SelectControl
											label={__('Order By', 'classified-listing')}
											options={ORDER_OPTIONS}
											value={orderby}
											onChange={(value) => {
												setAttributes({ orderby: value }),
													listingsSideEffectChange()
											}}
										/>

										<SelectControl
											label={__('Sort By', 'classified-listing')}
											options={SORT_OPTIONS}
											value={sortby}
											onChange={(value) => {
												setAttributes({ sortby: value }),
													listingsSideEffectChange()
											}}
										/>
										<RangeControl
											label={__('Listing Per Page', 'classified-listing')}
											value={perPage}
											allowReset={true}
											onChange={(value) => {
												setAttributes({ perPage: value }),
													listingsSideEffectChange()
											}}
											min={-1}
											max={100}
										/>

										<SelectControl
											label={__('Image Size', 'classified-listing')}
											options={imageSize}
											value={image_size}
											onChange={(value) => {
												setAttributes({ image_size: value }),
													listingsSideEffectChange()
											}}
										/>

										{image_size == 'custom' &&
											<>
												<RangeControl
													label={__('Width', 'classified-listing')}
													value={custom_image_width}
													onChange={(value) => {
														setAttributes({ custom_image_width: value }),
															listingsSideEffectChange()
													}}
													min={2}
													max={1000}
													step={2}
												/>
												<RangeControl
													label={__('Height', 'classified-listing')}
													value={custom_image_height}
													onChange={(value) => {
														setAttributes({ custom_image_height: value }),
															listingsSideEffectChange()
													}}
													min={2}
													max={1000}
													step={2}
												/>
											</>
										}

									</PanelBody>


									<PanelBody title={__('Slider Options', 'classified-listing')} initialOpen={false}>
										<ToggleControl
											label={__("Auto Heighit", "classified-listing")}
											checked={slider_options["autoHeight"]}
											onChange={(autoHeight) => {
												setAttributes({ slider_options: { ...slider_options, autoHeight } })
											}}
										/>

										<ToggleControl
											label={__("Loop", "classified-listing")}
											checked={slider_options["loop"]}
											onChange={(loop) => {
												setAttributes({ slider_options: { ...slider_options, loop } })
											}}
										/>

										<div style={{ marginBottom: '10px' }}>
											<ToggleControl
												label={__("Autoplay", "classified-listing")}
												checked={slider_options["autoPlay"]}
												onChange={(autoPlay) => {
													setAttributes({ slider_options: { ...slider_options, autoPlay } })
												}}
											/>

										</div>

										{slider_options["autoPlay"] == true && <>
											<ToggleControl
												label={__("Stop On Hover", "classified-listing")}
												checked={slider_options["stopOnHover"]}
												onChange={(stopOnHover) => {
													setAttributes({ slider_options: { ...slider_options, stopOnHover } })
												}}
											/>
											<SelectControl
												label={__('Autoplay Delay', 'classified-listing')}
												options={AUTOPLAY_DELAY}
												value={slider_options["autoPlayDelay"]}
												onChange={(autoPlayDelay) => {
													setAttributes({ slider_options: { ...slider_options, autoPlayDelay } })
												}}
											/>
										</>}

										<RangeControl
											label={__('Slide Transition Speed', 'classified-listing')}
											value={slider_options["autoPlaySlideSpeed"]}
											onChange={(autoPlaySlideSpeed) => setAttributes({ slider_options: { ...slider_options, autoPlaySlideSpeed } })}
											min={1000}
											max={5000}
										/>

										<RangeControl
											label={__('Space Between', 'classified-listing')}
											value={slider_options["spaceBetween"]}
											onChange={(spaceBetween) => setAttributes({ slider_options: { ...slider_options, spaceBetween } })}
											min={0}
											max={100}
										/>

										<ToggleControl
											label={__("Arrow Navigation", "classified-listing")}
											checked={slider_options["arrowNavigation"]}
											onChange={(arrowNavigation) => {
												setAttributes({ slider_options: { ...slider_options, arrowNavigation } })
											}}
										/>

										{slider_options["arrowNavigation"] && <SelectControl
											label={__('Arrow Position', 'classified-listing')}
											options={ARROW_POSITION}
											value={slider_options["arrowPosition"]}
											onChange={(arrowPosition) => {
												setAttributes({ slider_options: { ...slider_options, arrowPosition } })
											}}
										/>}

										<ToggleControl
											label={__("Dot Navigation", "classified-listing")}
											checked={slider_options["dotNavigation"]}
											onChange={(dotNavigation) => {
												setAttributes({ slider_options: { ...slider_options, dotNavigation } })
											}}
										/>

										{slider_options["dotNavigation"] && <SelectControl
											label={__('Dot style', 'classified-listing')}
											options={DOT_STYLE_OPTIONS}
											value={slider_options["dotStyle"]}
											onChange={(dotStyle) => {
												setAttributes({ slider_options: { ...slider_options, dotStyle } })
											}}
										/>}

										<ToggleControl
											label={__("Slider Loader", "classified-listing")}
											checked={slider_options["sliderLoader"]}
											onChange={(sliderLoader) => setAttributes({
												slider_options: { ...slider_options, sliderLoader }
											})}
										/>

									</PanelBody>

									<PanelBody title={__("Content Visibility", "classified-listing")} initialOpen={false}>

										<ToggleControl
											label={__("Title", "classified-listing")}
											checked={content_visibility["title"]}
											onChange={(title) => setAttributes({
												content_visibility: { ...content_visibility, title }
											})}
										/>

										<ToggleControl
											label={__("Thumbnail", "classified-listing")}
											checked={content_visibility["thumbnail"]}
											onChange={(thumbnail) => setAttributes({
												content_visibility: { ...content_visibility, thumbnail }
											})}
										/>

										<ToggleControl
											label={__("Short Description", "classified-listing")}
											checked={content_visibility["grid_content"]}
											onChange={(grid_content) => setAttributes({
												content_visibility: { ...content_visibility, grid_content }
											})}
										/>

										{content_visibility["grid_content"] &&
											< RangeControl
												label={__('Description Limit', 'classified-listing')}
												value={content_limit}
												onChange={(value) => setAttributes({ content_limit: value })}
												min={2}
												max={256}
												step={2}
											/>}

										<ToggleControl
											label={__("Badge", "classified-listing")}
											checked={content_visibility["badge"]}
											onChange={(badge) => setAttributes({
												content_visibility: { ...content_visibility, badge }
											})}
										/>

										<ToggleControl
											label={__("Sold", "classified-listing")}
											checked={content_visibility["sold"]}
											onChange={(sold) => setAttributes({
												content_visibility: { ...content_visibility, sold }
											})}
										/>

										<ToggleControl
											label={__("Location", "classified-listing")}
											checked={content_visibility["location"]}
											onChange={(location) => setAttributes({
												content_visibility: { ...content_visibility, location }
											})}
										/>

										<ToggleControl
											label={__("Category", "classified-listing")}
											checked={content_visibility["category"]}
											onChange={(category) => setAttributes({
												content_visibility: { ...content_visibility, category }
											})}
										/>

										<ToggleControl
											label={__("Date", "classified-listing")}
											checked={content_visibility["date"]}
											onChange={(date) => setAttributes({
												content_visibility: { ...content_visibility, date }
											})}
										/>

										<ToggleControl
											label={__("Price", "classified-listing")}
											checked={content_visibility["price"]}
											onChange={(price) => setAttributes({
												content_visibility: { ...content_visibility, price }
											})}
										/>

										<ToggleControl
											label={__("Author", "classified-listing")}
											checked={content_visibility["author"]}
											onChange={(author) => setAttributes({
												content_visibility: { ...content_visibility, author }
											})}
										/>

										<ToggleControl
											label={__("Views", "classified-listing")}
											checked={content_visibility["view"]}
											onChange={(view) => setAttributes({
												content_visibility: { ...content_visibility, view }
											})}
										/>

										<ToggleControl
											label={__("Listing Type", "classified-listing")}
											checked={content_visibility["listing_type"]}
											onChange={(listing_type) => setAttributes({
												content_visibility: { ...content_visibility, listing_type }
											})}
										/>

										{(col_style["style"] == "list" && (col_style["style_list"] == "1" || col_style["style_list"] == "2")) ? (
											<ToggleControl
												label={__("Details Button", "classified-listing")}
												checked={content_visibility["details_btn"]}
												onChange={(details_btn) => setAttributes({
													content_visibility: { ...content_visibility, details_btn }
												})}
											/>
										) : ''}

										<ToggleControl
											label={__("Phone Button", "classified-listing")}
											checked={content_visibility["phone_btn"]}
											onChange={(phone_btn) => setAttributes({
												content_visibility: { ...content_visibility, phone_btn }
											})}
										/>

										<ToggleControl
											label={__("Favourit Button", "classified-listing")}
											checked={content_visibility["favourit_btn"]}
											onChange={(favourit_btn) => setAttributes({
												content_visibility: { ...content_visibility, favourit_btn }
											})}
										/>
										<ToggleControl
											label={__("Quick View Button", "classified-listing")}
											checked={content_visibility["quick_btn"]}
											onChange={(quick_btn) => setAttributes({
												content_visibility: { ...content_visibility, quick_btn }
											})}
										/>
										<ToggleControl
											label={__("Compare  Button", "classified-listing")}
											checked={content_visibility["compare_btn"]}
											onChange={(compare_btn) => setAttributes({
												content_visibility: { ...content_visibility, compare_btn }
											})}
										/>
										{(col_style["style"] == "1" || col_style["style"] == "2" || col_style["style"] == "4") ? (
											<SelectControl
												label={__('Action Button Layout', 'classified-listing')}
												options={
													[
														{ label: "Horizontal Layout", value: "horizontal-layout" },
														{ label: "Vertical Layout", value: "vertical-layout" },
													]
												}
												value={content_visibility["actionLayout"]}
												onChange={(actionLayout) => setAttributes({
													content_visibility: { ...content_visibility, actionLayout }
												})}
											/>
										) : ''}

									</PanelBody>

									<PanelBody title={__('Number of Responsive cols', 'classified-listing')} initialOpen={false}>
										<SelectControl
											label={__('Desktops: >1199px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_xl}
											onChange={(col_xl) => {
												setAttributes({ col_xl })
											}}
										/>
										<SelectControl
											label={__('Desktops: >991px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_lg}
											onChange={(col_lg) => {
												setAttributes({ col_lg })
											}}
										/>
										<SelectControl
											label={__('Tablets: >767px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_md}
											onChange={(col_md) => {
												setAttributes({ col_md })
											}}
										/>
										<SelectControl
											label={__('Phones: >575px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_sm}
											onChange={(col_sm) => {
												setAttributes({ col_sm })
											}}
										/>
										<SelectControl
											label={__('Small Phones: <576px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_mobile}
											onChange={(col_mobile) => {
												setAttributes({ col_mobile })
											}}
										/>
									</PanelBody>
								</>
							)}

							{tab.name === "styles" && (
								<>
									<PanelBody title={__("Item Wrapper", "classified-listing")} initialOpen={true}>
										<BaseControl label={__("Background", "classified-listing")}>
											<ColorPalette
												className="rtcl-gb-colorpalette"
												colors={COLORS}
												value={colBGColor}
												onChange={(colBGColor) => setAttributes({
													colBGColor
												})}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControlCustom
												selectedUnit={col_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													col_padding: { ...col_padding, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Wrapper Padding", "classified-listing")}
												top={col_padding["top"]}
												right={col_padding["right"]}
												bottom={col_padding["bottom"]}
												left={col_padding["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													col_padding: { ...col_padding, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControlCustom
												selectedUnit={content_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													content_padding: { ...content_padding, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Content Padding", "classified-listing")}
												top={content_padding["top"]}
												right={content_padding["right"]}
												bottom={content_padding["bottom"]}
												left={content_padding["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													content_padding: { ...content_padding, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>

										<PanelBody title={__("Border")} initialOpen={false}>
											<ColorControl
												label={__("Border Color")}
												color={colBorderColor}
												onChange={(colBorderColor) => setAttributes({
													colBorderColor
												})
												}
											/>

											<BaseControl label={__("Width", "classified-listing")}>
												<UnitControl
													value={colBorderWith}
													onChange={(colBorderWith) => setAttributes({
														colBorderWith
													})
													}
												/>
											</BaseControl>

											<BaseControl label={__("Border Radius", "classified-listing")}>
												<UnitControl
													value={colBorderRadius}
													onChange={(colBorderRadius) => setAttributes({
														colBorderRadius
													})
													}
												/>
											</BaseControl>
										</PanelBody>


										<PanelBody title={__("Box Shadow")} initialOpen={false}>
											<BaseControl>
												<ButtonGroup className="rtcl-gb-inspector-btn-group">
													{NORMAL_HOVER.map((item) => (
														<Button
															isLarge
															isPrimary={colBoxShadowStyle === item.value}
															isSecondary={colBoxShadowStyle !== item.value}
															onClick={() => setAttributes({
																colBoxShadowStyle: item.value
															})}
														>
															{item.label}
														</Button>
													))}
												</ButtonGroup>
											</BaseControl>

											{colBoxShadowStyle === "normal" && (
												<BaseControl>
													<ColorControl
														label={__("Color")}
														color={colBoxShadow['color']}
														onChange={(color) => setAttributes({
															colBoxShadow: { ...colBoxShadow, color }
														})}
													/>
													<RangeControl
														label={__("Horizontal")}
														value={parseInt(colBoxShadow['width']["top"])}
														onChange={(top) => setAttributes({
															colBoxShadow: { ...colBoxShadow, width: { ...colBoxShadow['width'], top } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Vertical")}
														value={parseInt(colBoxShadow['width']["right"])}
														onChange={(right) => setAttributes({
															colBoxShadow: { ...colBoxShadow, width: { ...colBoxShadow['width'], right } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Blur")}
														value={parseInt(colBoxShadow['width']["bottom"])}
														onChange={(bottom) => setAttributes({
															colBoxShadow: { ...colBoxShadow, width: { ...colBoxShadow['width'], bottom } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Spread")}
														value={parseInt(colBoxShadow['width']["left"])}
														onChange={(left) => setAttributes({
															colBoxShadow: { ...colBoxShadow, width: { ...colBoxShadow['width'], left } }
														})}
														min={0}
														max={100}
													/>
													<SelectControl
														label={__('Position', 'classified-listing')}
														options={
															[
																{ label: __("Outline"), value: "" },
																{ label: __("Inset"), value: "inset" },
															]
														}
														value={colBoxShadow["inset"]}
														onChange={(inset) => {
															setAttributes({ colBoxShadow: { ...colBoxShadow, inset } })
														}}
													/>
												</BaseControl>
											)}

											{colBoxShadowStyle === "hover" && (
												<BaseControl>
													<ColorControl
														label={__("Color")}
														color={colBoxShadowHover['color']}
														onChange={(color) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, color }
														})}
													/>
													<RangeControl
														label={__("Horizontal")}
														value={parseInt(colBoxShadowHover['width']["top"])}
														onChange={(top) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, width: { ...colBoxShadowHover['width'], top } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Vertical")}
														value={parseInt(colBoxShadowHover['width']["right"])}
														onChange={(right) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, width: { ...colBoxShadowHover['width'], right } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Blur")}
														value={parseInt(colBoxShadowHover['width']["bottom"])}
														onChange={(bottom) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, width: { ...colBoxShadowHover['width'], bottom } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Spread")}
														value={parseInt(colBoxShadowHover['width']["left"])}
														onChange={(left) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, width: { ...colBoxShadowHover['width'], left } }
														})}
														min={0}
														max={100}
													/>
													<SelectControl
														label={__('Position', 'classified-listing')}
														options={
															[
																{ label: __("Outline"), value: "" },
																{ label: __("Inset"), value: "inset" },
															]
														}
														value={colBoxShadowHover["inset"]}
														onChange={(inset) => {
															setAttributes({ colBoxShadowHover: { ...colBoxShadowHover, inset } })
														}}
													/>
												</BaseControl>
											)}
										</PanelBody>
									</PanelBody>

									<PanelBody title={__("Promotion")} initialOpen={false}>
										<ColorControl
											label={__("Top Background Color")}
											color={ptopBGColor}
											onChange={(ptopBGColor) => setAttributes({ ptopBGColor })}
										/>

										<ColorControl
											label={__("Top Border Color")}
											color={ptopBDColor}
											onChange={(ptopBDColor) => setAttributes({
												ptopBDColor
											})
											}
										/>
										<ColorControl
											label={__("Featured Background Color")}
											color={pfeaturedBGColor}
											onChange={(pfeaturedBGColor) => setAttributes({
												pfeaturedBGColor
											})}
										/>

										<ColorControl
											label={__("Featured Border Color")}
											color={pfeaturedBDColor}
											onChange={(pfeaturedBDColor) => setAttributes({
												pfeaturedBDColor
											})
											}
										/>
									</PanelBody>

									<PanelBody title={__("Title", "classified-listing")} initialOpen={false}>
										<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (

													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControlCustom
															selectedUnit={titleTypo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																titleTypo: { ...titleTypo, size: { ...titleTypo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(titleTypo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																titleTypo: { ...titleTypo, size: { ...titleTypo["size"], lg } }
															})}
															min={0}
															step={TITLE_SIZE_STEP}
															max={TITLE_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={titleTypo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ titleTypo: { ...titleTypo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={titleTypo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ titleTypo: { ...titleTypo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(titleTypo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ titleTypo: { ...titleTypo, spacing: { ...titleTypo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(titleTypo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ titleTypo: { ...titleTypo, height: { ...titleTypo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<BaseControl>
											<ButtonGroup className="rtcl-gb-inspector-btn-group">
												{NORMAL_HOVER.map((item) => (
													<Button
														isLarge
														isPrimary={titleColorStyle === item.value}
														isSecondary={titleColorStyle !== item.value}
														onClick={() => setAttributes({
															titleColorStyle: item.value
														})}
													>
														{item.label}
													</Button>
												))}
											</ButtonGroup>
										</BaseControl>

										{titleColorStyle === "normal" && (
											<ColorPalette
												className="rtcl-gb-colorpalette"
												colors={COLORS}
												value={titleColor}
												onChange={(titleColor) => setAttributes({
													titleColor
												})}
											/>
										)}

										{titleColorStyle === "hover" && (
											<ColorPalette
												className="rtcl-gb-colorpalette"
												colors={COLORS}
												value={titleHoverColor}
												onChange={(titleHoverColor) => setAttributes({
													titleHoverColor
												})}
											/>
										)}

										<BaseControl>
											<UnitControlCustom
												selectedUnit={title_margin["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													title_margin: { ...title_margin, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Title Margin", "classified-listing")}
												top={title_margin["top"]}
												right={title_margin["right"]}
												bottom={title_margin["bottom"]}
												left={title_margin["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													title_margin: { ...title_margin, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>
									</PanelBody>

									<PanelBody title={__("Badge", "classified-listing")} initialOpen={false}>

										<BaseControl>
											<UnitControlCustom
												selectedUnit={badge_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													badge_padding: { ...badge_padding, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Badge Padding", "classified-listing")}
												top={badge_padding["top"]}
												right={badge_padding["right"]}
												bottom={badge_padding["bottom"]}
												left={badge_padding["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													badge_padding: { ...badge_padding, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControlCustom
												selectedUnit={badge_margin["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													badge_margin: { ...badge_margin, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Badge Margin", "classified-listing")}
												top={badge_margin["top"]}
												right={badge_margin["right"]}
												bottom={badge_margin["bottom"]}
												left={badge_margin["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													badge_margin: { ...badge_margin, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>

										<BaseControl label={__("Sold Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControlCustom
															selectedUnit={soldTypo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																soldTypo: { ...soldTypo, size: { ...soldTypo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(soldTypo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																soldTypo: { ...soldTypo, size: { ...soldTypo["size"], lg } }
															})}
															min={0}
															step={SOLD_SIZE_STEP}
															max={SOLD_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={soldTypo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ soldTypo: { ...soldTypo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={soldTypo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ soldTypo: { ...soldTypo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(soldTypo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ soldTypo: { ...soldTypo, spacing: { ...soldTypo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(soldTypo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ soldTypo: { ...soldTypo, height: { ...soldTypo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>
										<ColorControl
											label={__("Sold Background Color")}
											color={soldBGColor}
											onChange={(soldBGColor) => setAttributes({
												soldBGColor
											})}
										/>
										<ColorControl
											label={__("Sold Color")}
											color={soldColor}
											onChange={(soldColor) => setAttributes({
												soldColor
											})}
										/>

										<BaseControl label={__("Badge Typography")} className="rtcl-gb-typography-base">

											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControlCustom
															selectedUnit={badgeTypo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																badgeTypo: { ...badgeTypo, size: { ...badgeTypo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(badgeTypo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																badgeTypo: { ...badgeTypo, size: { ...badgeTypo["size"], lg } }
															})}
															min={0}
															step={BADGE_SIZE_STEP}
															max={BADGE_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={badgeTypo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ badgeTypo: { ...badgeTypo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={badgeTypo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ badgeTypo: { ...badgeTypo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(badgeTypo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ badgeTypo: { ...badgeTypo, spacing: { ...badgeTypo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(badgeTypo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ badgeTypo: { ...badgeTypo, height: { ...badgeTypo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<ColorControl
											label={__("New Background Color")}
											color={bnewBGColor}
											onChange={(bnewBGColor) => setAttributes({
												bnewBGColor
											})}
										/>
										<ColorControl
											label={__("New Color")}
											color={bnewColor}
											onChange={(bnewColor) => setAttributes({
												bnewColor
											})}
										/>
										<ColorControl
											label={__("Featured Background Color")}
											color={bfeaturedBGColor}
											onChange={(bfeaturedBGColor) => setAttributes({
												bfeaturedBGColor
											})}
										/>
										<ColorControl
											label={__("Featured Color")}
											color={bfeaturedColor}
											onChange={(bfeaturedColor) => setAttributes({
												bfeaturedColor
											})}
										/>
										<ColorControl
											label={__("Top Background Color")}
											color={btopBGColor}
											onChange={(btopBGColor) => setAttributes({
												btopBGColor
											})}
										/>
										<ColorControl
											label={__("Top Color")}
											color={btopColor}
											onChange={(btopColor) => setAttributes({
												btopColor
											})}
										/>

										<ColorControl
											label={__("Popular Background Color")}
											color={bpopularBGColor}
											onChange={(bpopularBGColor) => setAttributes({
												bpopularBGColor
											})}
										/>
										<ColorControl
											label={__("Popular Color")}
											color={bpopularColor}
											onChange={(bpopularColor) => setAttributes({
												bpopularColor
											})}
										/>

										<ColorControl
											label={__("BumpUp Background Color")}
											color={bbumpBGColor}
											onChange={(bbumpBGColor) => setAttributes({
												bbumpBGColor
											})}
										/>
										<ColorControl
											label={__("BumpUp Color")}
											color={bbumpColor}
											onChange={(bbumpColor) => setAttributes({
												bbumpColor
											})}
										/>

									</PanelBody>

									<PanelBody title={__("Meta", "classified-listing")} initialOpen={false}>

										<UnitControlCustom
											selectedUnit={meta_margin["unit"]}
											unitTypes={[
												{ label: "px", value: "px" },
												{ label: "em", value: "em" },
												{ label: "%", value: "%" },
											]}
											onClick={(unit) => setAttributes({
												meta_margin: { ...meta_margin, unit },
											})
											}
										/>
										<DimensionsControl
											label={__("Meta Margin", "classified-listing")}
											top={meta_margin["top"]}
											right={meta_margin["right"]}
											bottom={meta_margin["bottom"]}
											left={meta_margin["left"]}
											onChange={({ top, right, bottom, left }) => setAttributes({
												meta_margin: { ...meta_margin, top, bottom, left, right },
											})
											}
										/>

										<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControlCustom
															selectedUnit={metaTypo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																metaTypo: { ...metaTypo, size: { ...metaTypo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(metaTypo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																metaTypo: { ...metaTypo, size: { ...metaTypo["size"], lg } }
															})}
															min={0}
															step={META_SIZE_STEP}
															max={META_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={metaTypo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ metaTypo: { ...metaTypo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={metaTypo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ metaTypo: { ...metaTypo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(metaTypo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ metaTypo: { ...metaTypo, spacing: { ...metaTypo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(metaTypo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ metaTypo: { ...metaTypo, height: { ...metaTypo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<BaseControl>
											<ButtonGroup className="rtcl-gb-inspector-btn-group">
												{NORMAL_HOVER.map((item) => (
													<Button
														isLarge
														isPrimary={metaColorStyle === item.value}
														isSecondary={metaColorStyle !== item.value}
														onClick={() => setAttributes({
															metaColorStyle: item.value
														})}
													>
														{item.label}
													</Button>
												))}
											</ButtonGroup>
										</BaseControl>

										{metaColorStyle === "normal" && (
											<>
												<ColorControl
													label={__("Color")}
													color={metaColor}
													onChange={(metaColor) => setAttributes({
														metaColor
													})}
												/>
												<ColorControl
													label={__("Icon Color")}
													color={metaIconColor}
													onChange={(metaIconColor) => setAttributes({
														metaIconColor
													})}
												/>
												<ColorControl
													label={__("Category Color")}
													color={metaCatColor}
													onChange={(metaCatColor) => setAttributes({
														metaCatColor
													})}
												/>
											</>
										)}

										{metaColorStyle === "hover" && (
											<>
												<ColorControl
													label={__("Color")}
													color={metaHoverColor}
													onChange={(metaHoverColor) => setAttributes({
														metaHoverColor
													})}
												/>
												<ColorControl
													label={__("Icon Color")}
													color={metaIconHoverColor}
													onChange={(metaIconHoverColor) => setAttributes({
														metaIconHoverColor
													})}
												/>
												<ColorControl
													label={__("Category Color")}
													color={metaCatHoverColor}
													onChange={(metaCatHoverColor) => setAttributes({
														metaCatHoverColor
													})}
												/>
											</>
										)}
									</PanelBody>

									<PanelBody title={__("Price", "classified-listing")} initialOpen={false}>
										<ColorControl
											label={__("Background Color")}
											color={priceBGColor}
											onChange={(priceBGColor) => setAttributes({
												priceBGColor
											})}
										/>

										<ColorControl
											label={__("Text Color")}
											color={priceColor}
											onChange={(priceColor) => setAttributes({
												priceColor
											})}
										/>

										<RangeControl
											label={__("Price Font Size")}
											value={priceFontSize}
											onChange={(priceFontSize) => setAttributes({
												priceFontSize
											})}
											min={0}
											max={100}
										/>

										<SelectControl
											label={__("Price Font Weight")}
											value={priceFontWeight}
											options={FONT_WEIGHTS}
											onChange={(priceFontWeight) => setAttributes({
												priceFontWeight
											})}
										/>

										<ColorControl
											label={__("Unit Label Text Color")}
											color={unitLabelColor}
											onChange={(unitLabelColor) => setAttributes({
												unitLabelColor
											})}
										/>
										<RangeControl
											label={__("Unit Label Font Size")}
											value={unitLFSize}
											onChange={(unitLFSize) => setAttributes({
												unitLFSize
											})}
											min={0}
											max={100}
										/>
										<SelectControl
											label={__("Unit Label Font Weight")}
											value={unitLFSizeWeight}
											options={FONT_WEIGHTS}
											onChange={(unitLFSizeWeight) => setAttributes({
												unitLFSizeWeight
											})}
										/>

										<BaseControl>
											<UnitControlCustom
												selectedUnit={price_margin["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													price_margin: { ...price_margin, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Price Margin", "classified-listing")}
												top={price_margin["top"]}
												right={price_margin["right"]}
												bottom={price_margin["bottom"]}
												left={price_margin["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													price_margin: { ...price_margin, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>
									</PanelBody>


									<PanelBody title={__("Button", "classified-listing")} initialOpen={false}>
										<BaseControl>
											<ButtonGroup className="rtcl-gb-inspector-btn-group">
												{NORMAL_HOVER.map((item) => (
													<Button
														isLarge
														isPrimary={btnColorStyle === item.value}
														isSecondary={btnColorStyle !== item.value}
														onClick={() => setAttributes({
															btnColorStyle: item.value
														})}
													>
														{item.label}
													</Button>
												))}
											</ButtonGroup>
										</BaseControl>

										{btnColorStyle === "normal" && (
											<>
												<ColorControl
													label={__("Background Color")}
													color={btnBGColor}
													onChange={(btnBGColor) => setAttributes({
														btnBGColor
													})}
												/>
												<ColorControl
													label={__("Button Text Color")}
													color={btnColor}
													onChange={(btnColor) => setAttributes({
														btnColor
													})}
												/>
												{(col_style["style"] == "5") ?
													<ColorControl
														label={__("Border Color")}
														color={btnBorderColor}
														onChange={(btnBorderColor) => setAttributes({
															btnBorderColor
														})}
													/>
													: ''}
											</>
										)}

										{btnColorStyle === "hover" && (
											<>
												<ColorControl
													label={__("Background Color")}
													color={btnBGHoverColor}
													onChange={(btnBGHoverColor) => setAttributes({
														btnBGHoverColor
													})}
												/>
												<ColorControl
													label={__("Button Text Color")}
													color={btnHoverColor}
													onChange={(btnHoverColor) => setAttributes({
														btnHoverColor
													})}
												/>

												{(col_style["style"] == '5') ?
													<ColorControl
														label={__("Border Color")}
														color={btnHoverBorderColor}
														onChange={(btnHoverBorderColor) => setAttributes({
															btnHoverBorderColor
														})}
													/>
													: ''}
											</>
										)}
									</PanelBody>

									{content_visibility["grid_content"] ?
										<PanelBody title={__("Description", "classified-listing")} initialOpen={false}>

											<UnitControlCustom
												selectedUnit={content_margin["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													content_margin: { ...content_margin, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Content Margin", "classified-listing")}
												top={content_margin["top"]}
												right={content_margin["right"]}
												bottom={content_margin["bottom"]}
												left={content_margin["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													content_margin: { ...content_margin, top, bottom, left, right },
												})
												}
											/>

											<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
												<Dropdown
													className="rtcl-gb-typography-dropdown"
													contentClassName="my-popover-content-classname"
													position="bottom right"
													renderToggle={({ isOpen, onToggle }) => (
														<Button
															isSmall
															onClick={onToggle}
															aria-expanded={isOpen}
															icon="edit"
														></Button>
													)}
													renderContent={() => (
														<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
															<UnitControlCustom
																selectedUnit={contentTypo["size"]["unit"]}
																unitTypes={[
																	{ label: "px", value: "px" },
																	{ label: "%", value: "%" },
																	{ label: "em", value: "em" },
																]}
																onClick={(unit) => setAttributes({
																	contentTypo: { ...contentTypo, size: { ...contentTypo["size"], unit } }
																})}
															/>

															<RangeControl
																label={__("Font Size")}
																value={parseInt(contentTypo["size"]["lg"])}
																onChange={(lg) => setAttributes({
																	contentTypo: { ...contentTypo, size: { ...contentTypo["size"], lg } }
																})}
																min={0}
																step={CONTENT_SIZE_STEP}
																max={CONTENT_SIZE_MAX}
															/>

															<SelectControl
																label={__("Font Weight")}
																value={contentTypo["weight"]}
																options={FONT_WEIGHTS}
																onChange={(weight) =>
																	setAttributes({ contentTypo: { ...contentTypo, weight } })
																}
															/>

															<SelectControl
																label={__("Text Transform")}
																value={contentTypo["transform"]}
																options={TEXT_TRANSFORM}
																onChange={(transform) =>
																	setAttributes({ contentTypo: { ...contentTypo, transform } })
																}
															/>

															<RangeControl
																label={__("Letter Spacing")}
																value={parseInt(contentTypo["spacing"]["lg"])}
																onChange={(lg) =>
																	setAttributes({ contentTypo: { ...contentTypo, spacing: { ...contentTypo["spacing"], lg } } })
																}
																min={0}
																max={10}
															/>

															<RangeControl
																label={__("Line Height")}
																value={parseInt(contentTypo["height"]["lg"])}
																onChange={(lg) =>
																	setAttributes({ contentTypo: { ...contentTypo, height: { ...contentTypo["height"], lg } } })
																}
																min={-1}
																max={100}
															/>

														</div>
													)}
												/>
											</BaseControl>
										</PanelBody>
										: ''}

									{slider_options["arrowNavigation"] &&
										<PanelBody title={__("Arrow Navigation", "classified-listing")} initialOpen={false} >
											<ColorControl
												label={__("Background Color")}
												color={arrowBGColor}
												onChange={(arrowBGColor) => setAttributes({
													arrowBGColor
												})
												}
											/>
											<ColorControl
												label={__("Hover Background Color")}
												color={arrowBGHoverColor}
												onChange={(arrowBGHoverColor) => setAttributes({
													arrowBGHoverColor
												})
												}
											/>

											<ColorControl
												label={__("Icon Color")}
												color={arrowIconColor}
												onChange={(arrowIconColor) => setAttributes({
													arrowIconColor
												})
												}
											/>

											<ColorControl
												label={__("Hover Icon Color")}
												color={arrowIconHoverColor}
												onChange={(arrowIconHoverColor) => setAttributes({
													arrowIconHoverColor
												})
												}
											/>

										</PanelBody>
									}

									{slider_options["dotNavigation"] &&
										<PanelBody title={__("Dot Navigation", "classified-listing")} initialOpen={false} >
											<RangeControl
												label={__("Dot Navigation Spacing")}
												value={dotSpacing}
												onChange={(dotSpacing) => setAttributes({
													dotSpacing
												})}
												min={-50}
												max={100}
											/>

											<ColorControl
												label={__("Background Color")}
												color={dotBGColor}
												onChange={(dotBGColor) => setAttributes({
													dotBGColor
												})
												}
											/>

											<ColorControl
												label={__("Active Background Color")}
												color={dotActiveBGColor}
												onChange={(dotActiveBGColor) => setAttributes({
													dotActiveBGColor
												})
												}
											/>
										</PanelBody>
									}
								</>
							)}

							{tab.name === "advance" && (
								<>
									<PanelBody title={__("Main Wrapper", "classified-listing")} initialOpen={true}>
										<UnitControlCustom
											selectedUnit={container_padding["unit"]}
											unitTypes={[
												{ label: "px", value: "px" },
												{ label: "em", value: "em" },
												{ label: "%", value: "%" },
											]}
											onClick={(unit) => setAttributes({
												container_padding: { ...container_padding, unit },
											})
											}
										/>
										<DimensionsControl
											label={__("Main Wrapper Padding", "classified-listing")}
											top={container_padding["top"]}
											right={container_padding["right"]}
											bottom={container_padding["bottom"]}
											left={container_padding["left"]}
											onChange={({ top, right, bottom, left }) => setAttributes({
												container_padding: { ...container_padding, top, bottom, left, right },
											})
											}
										/>
										<UnitControlCustom
											selectedUnit={container_margin["unit"]}
											unitTypes={[
												{ label: "px", value: "px" },
												{ label: "em", value: "em" },
												{ label: "%", value: "%" },
											]}
											onClick={(unit) => setAttributes({
												container_margin: { ...container_margin, unit },
											})
											}
										/>
										<DimensionsControl
											label={__("Main Wrapper Margin", "classified-listing")}
											top={container_margin["top"]}
											right={container_margin["right"]}
											bottom={container_margin["bottom"]}
											left={container_margin["left"]}
											onChange={({ top, right, bottom, left }) => setAttributes({
												container_margin: { ...container_margin, top, bottom, left, right },
											})
											}
										/>
										<BaseControl label={__("Background Color", "classified-listing")}>
											<ColorPalette
												className="rtcl-gb-colorpalette"
												colors={COLORS}
												value={containerBGColor}
												onChange={(containerBGColor) => setAttributes({
													containerBGColor
												})}
											/>
										</BaseControl>
									</PanelBody>
								</>
							)}

						</div>
					)}
				</TabPanel>
			</div >
		</InspectorControls >
	)

}

export default Inspector;